import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

export default function CustomMenu({items = [], anchorEl ,setAnchorEl, handleClick ,handleClose, children,MenuItemSX = {}}) {
  const open = Boolean(anchorEl);

  return (
    <div style={{position: "relative"}}>
      {/* <Button
        id="demo-positioned-button"
        aria-controls={open ? 'demo-positioned-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        Dashboard
      </Button> */}
      {children}
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {items?.map(item => <MenuItem sx={{...MenuItemSX}} onClick={() => {handleClick(item); handleClose();}}>{item?.name}</MenuItem>)}
      </Menu>
    </div>
  );
}